import axios from "axios";
import { OceanCarriersResponseDTO } from "./response.types";
import { injectApiKeyHeader, injectDataInterceptor, injectSearchCustomHeader } from "shared/api/utils/api.utils";

const CARRIERS_API_URL = "https://api.qubictron.com/tracking/v1/ocean/carriers";

const sealinesRequestInstance = axios.create();
sealinesRequestInstance.defaults.baseURL = CARRIERS_API_URL;
injectApiKeyHeader(sealinesRequestInstance);
injectSearchCustomHeader(sealinesRequestInstance);
injectDataInterceptor(sealinesRequestInstance);

class SealinesApi {
  public getSeaLines() {
    return sealinesRequestInstance.get<OceanCarriersResponseDTO, OceanCarriersResponseDTO>("");
  }
}

export const sealinesService = new SealinesApi();
